import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { Company, CreateCompanyRequest, HttpResponse } from "@/types";

export function useCreateCompany() {
  const mutation = useMutation({
    mutationFn: async ({
      createCompanyRequest,
    }: {
      createCompanyRequest: CreateCompanyRequest;
    }) => {
      const path = "companies";
      const res = await guacHttpClient.post<
        Company,
        HttpResponse<Company>,
        CreateCompanyRequest
      >(path, createCompanyRequest);

      return res.data;
    },
  });

  return mutation;
}
